import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ModoTema } from '../theme';

interface TemaState {
  mode: ModoTema;
}

const CHAVE = 'cardapio-sischef:tema-mode';

function carregar(): TemaState {
  if (typeof localStorage === 'undefined') return { mode: 'light' };
  const v = localStorage.getItem(CHAVE);
  return { mode: v === 'dark' ? 'dark' : 'light' };
}

const temaSlice = createSlice({
  name: 'tema',
  initialState: carregar(),
  reducers: {
    definirModoTema(state, action: PayloadAction<ModoTema>) {
      state.mode = action.payload;
      localStorage.setItem(CHAVE, action.payload);
    },
    alternarModoTema(state) {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
      localStorage.setItem(CHAVE, state.mode);
    },
  },
});

export const { definirModoTema, alternarModoTema } = temaSlice.actions;
export const temaReducer = temaSlice.reducer;
